import {  Tabs, Badge } from 'antd'
import React, { useEffect, useState } from 'react'
import Main from '../../cpn/Main'
import '../../cpn/customTable.css'; 
import { useGetCYlistQuery,useTDspjdListQuery } from '../../store/DianShangYeWuApi';
import { 
    AuditOutlined,
    SolutionOutlined,
    ScheduleOutlined,
    FileDoneOutlined,
    ClockCircleOutlined,
    PlusOutlined,
    FileSearchOutlined
} from '@ant-design/icons';
import ReportListPending from './ReportListPending';
import ReportListSubmitted from './ReportListSubmitted';
import ReportListNeedApprove from './ReportListNeedApprove';
import ReportListApproved from './ReportListApproved';  
import ReportListNeedRead from './ReportListNeedRead';
import ReportAdd from './ReportAdd';
import ReportListAll from './ReportListAll';
function ReportList(props) {
    const qy_id = props.qy_id;
    const qy_name = props.qy_name;
    const yh_id = props.yh_id;
    const yh_name = props.yh_name;
    const yh_qx = props.yh_qx || '';
    //我的常用信息
    const [commonList,setCommonList] = useState({
        pt_data:[],
        cp_data:[],
        kh_data:[],
        jd_data:[],
        zb_data:[],
        bm_data:[],
    })
    const {data:commonListData,isSuccess:commonListIsSuccess} =useGetCYlistQuery({dsbzd_uid:yh_id},{refetchOnMountOrArgChange:1})
    useEffect(() => {
        if(commonListIsSuccess){
            if(commonListData.Status==='success'){
                const {pt_data,cp_data,kh_data,jd_data,zb_data,bm_data} = commonListData.Result;
                const pt_data_arr = pt_data.map((item) => {
                    return {value:item.dsbzd_dspt_id,label:item.dsbzd_dspt_name,key:'a'+item.dsbzd_dspt_id,num:item.num}
                })
                pt_data_arr.sort((a,b) => a.num - b.num)
                const cp_data_arr = cp_data.map((item) => {
                    return {value:item.dsbzd_dscp_id,label:item.dsbzd_dscp_name,key:'a'+item.dsbzd_dscp_id,num:item.num}
                })
                cp_data_arr.sort((a,b) => a.num - b.num)
                const kh_data_arr = kh_data.map((item) => {
                    return {value:item.dsbzd_kh_id,label:item.dsbzd_kh_name,key:'a'+item.dsbzd_kh_id,num:item.num}
                })
                kh_data_arr.sort((a,b) => a.num - b.num)
                const jd_data_arr = jd_data.map((item) => {
                    return {value:item.dsbzd_jd_id,label:item.dsbzd_jd_name,key:'a'+item.dsbzd_jd_id,num:item.num}
                })
                jd_data_arr.sort((a,b) => a.num - b.num)
                const zb_data_arr = zb_data.map((item) => {
                    return {value:item.dsbzd_zb_id,label:item.dsbzd_zb_name,key:'a'+item.dsbzd_zb_id,num:item.num}
                })
                zb_data_arr.sort((a,b) => a.num - b.num)
                const bm_data_arr = bm_data.map((item) => {
                    return {value:item.dsbzd_bm_id,label:item.dsbzd_bm_name,key:'a'+item.dsbzd_bm_id,num:item.num}
                })
                bm_data_arr.sort((a,b) => a.num - b.num)
                setCommonList({pt_data:pt_data_arr,cp_data:cp_data_arr,kh_data:kh_data_arr,jd_data:jd_data_arr,zb_data:zb_data_arr,bm_data:bm_data_arr})
            }
        }
    },[commonListData,commonListIsSuccess])
    const [activeKey, setActiveKey] = useState(localStorage.getItem('jtg-caiwu_report_active_key') || '1');
    
    //团队报账单审批节点
    const [spjdList, setSpjdList] = useState([]);
    const {data:spjdData, isSuccess:spjdIsSuccess} = useTDspjdListQuery({dsbzd_spjd_qy_id:qy_id,dsbzd_spjd_user_id:"1"},{skip:!yh_id});
    useEffect(() => {
        if(spjdIsSuccess && spjdData.Status === 'success'){
            setSpjdList(spjdData.Result);
        }
    }, [spjdData, spjdIsSuccess]);
    //
    return (
        <Main 
            selectedKeys={['/ReportList']} 
            qy_id={props.qy_id}
            qy_name={props.qy_name}
            yh_id={props.yh_id}
            yh_name={props.yh_name}
            loanNeedApproveNum={props.loanNeedApproveNum}
            loanNeedReadNum={props.loanNeedReadNum}
            loanRejectedNum={props.loanRejectedNum}
            loanEndNeedReadNum={props.loanEndNeedReadNum}
            reportRejectedNum={props.reportRejectedNum}
            reportNeedApproveNum={props.reportNeedApproveNum}
            reportNeedReadNum={props.reportNeedReadNum}
            reportEndNeedReadNum={props.reportEndNeedReadNum}
            expenseNeedApproveNum={props.expenseNeedApproveNum}
            expenseNeedReadNum={props.expenseNeedReadNum}
            expenseRejectedNum={props.expenseRejectedNum}
            expenseEndNeedReadNum={props.expenseEndNeedReadNum}
            ddzcNeedApproveNum={props.ddzcNeedApproveNum}
            ddzcNeedReadNum={props.ddzcNeedReadNum}
            ddzcRejectedNum={props.ddzcRejectedNum}
            ddzcEndNeedReadNum={props.ddzcEndNeedReadNum}
            ddsrNeedApproveNum={props.ddsrNeedApproveNum}
            ddsrNeedReadNum={props.ddsrNeedReadNum}
            ddsrRejectedNum={props.ddsrRejectedNum}
            ddsrEndNeedReadNum={props.ddsrEndNeedReadNum}
            invoiceNeedApproveNum={props.invoiceNeedApproveNum}
            invoiceNeedReadNum={props.invoiceNeedReadNum}
            invoiceRejectedNum={props.invoiceRejectedNum}
            invoiceEndNeedReadNum={props.invoiceEndNeedReadNum}
            yh_qx={props.yh_qx}
        >   
            <Tabs
                items={[
                    {
                        key: '0',
                        label: '新增',
                        children: <ReportAdd list={props.reportList} commonList={commonList} qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} spjdList={spjdList} yh_qx={yh_qx}/>,
                        icon: <PlusOutlined />,
                    },
                    {
                        key: '1',
                        label: '我未提交的',
                        children: <ReportListPending list={props.reportList} commonList={commonList} qy_id={qy_id} qy_name={qy_name} yh_id={yh_id} yh_name={yh_name} spjdList={spjdList} yh_qx={yh_qx}/>,
                        icon: <ClockCircleOutlined />,
                    },
                    {
                        key: '2',
                        label: <span>我已提交的<Badge count={Number(props.reportRejectedNum) + Number(props.reportEndNeedReadNum)}><span style={{color:'#fff'}}> 1</span></Badge></span>,
                        children: <ReportListSubmitted 
                                        list={props.reportList} 
                                        commonList={commonList} 
                                        spjdList={spjdList} 
                                        reportRejectedNum={props.reportRejectedNum} 
                                        qy_id={qy_id} 
                                        qy_name={qy_name} 
                                        yh_id={yh_id} 
                                        yh_name={yh_name} 
                                        yh_qx={yh_qx}
                                        reportEndNeedReadNum={props.reportEndNeedReadNum}
                                    />,
                        icon: <ScheduleOutlined />,
                    },
                    {
                        key: '3',
                        label: <span>需要我审批的<Badge count={props.reportNeedApproveNum}><span style={{color:'#fff'}}> 1</span></Badge></span>,
                        children: <ReportListNeedApprove yh_id={yh_id} yh_name={yh_name} qy_id={qy_id} qy_name={qy_name} spList={props.reportSpList} yh_qx={yh_qx}/>,
                        icon:<AuditOutlined />,
                    },
                    {
                        key: '4',
                        label: '我已审批的',
                        children: <ReportListApproved yh_id={yh_id} yh_name={yh_name} qy_id={qy_id} qy_name={qy_name} spList={props.reportSpList} yh_qx={yh_qx}/>,
                        icon:<FileDoneOutlined />,
                    },
                    {
                        key: '5',
                        label: <span>抄送给我的<Badge count={props.reportNeedReadNum}><span style={{color:'#fff'}}> 1</span></Badge></span>,
                        children: <ReportListNeedRead yh_id={yh_id} yh_name={yh_name} qy_id={qy_id} qy_name={qy_name} spList={props.reportSpList} yh_qx={yh_qx}/>,
                        icon:<SolutionOutlined />,
                    },
                    ...(yh_qx.includes('管理') ? [{
                        key: '6',
                        label: '全部单据',
                        children: <ReportListAll list={props.reportList} commonList={commonList} yh_id={yh_id} yh_name={yh_name} qy_id={qy_id} qy_name={qy_name} spjdList={spjdList} yh_qx={yh_qx}/>,
                        icon:<FileSearchOutlined />,
                    }] : []),
                  ]}
                  activeKey={activeKey} 
                  onChange={(key) => {    
                      setActiveKey(key)
                      localStorage.setItem('jtg-caiwu_report_active_key', key)
                  }}
            />         
           
        </Main>
    )
}

export default ReportList